<template>
  <div>
    <p>{{ safe }}</p>
    <p>{{ info.appCodeName }}</p>
    <p>{{ info.appName }}</p>
    <p>{{ info.appVersion }}</p>
  </div>
</template>

<script>
import safeAreaInsets from "safe-area-insets";

export default {
  data() {
    return {
      safe: {},
      info: window.navigator,
    };
  },
  created() {
    this.safe = safeAreaInsets;
  },
};
</script>
